import { useMutation, getApolloErrorMessage } from '@biletiniz/apollo';
import { SIGNUP } from './gql/sign-up';

export const useSignUp = () => {
  const [signUpMutation, { error, loading }] = useMutation(SIGNUP);

  const signUp = signUpInfo => {
    return signUpMutation({
      variables: signUpInfo,
    });
  };

  const initialValues = {
    name: '',
    surname: '',
    phoneNumber: '90 ',
    email: '',
    password: '',
    confirm: '',
    verifyPhone: true,
    termsOfService: false,
  };

  return {
    error: getApolloErrorMessage(error),
    signUp,
    loading,
    initialValues,
  };
};
